<template>
  <div class="chat">
    <div class="chat-title">{{$t('components_gameroom_chat_1788')}}</div>
    <chat-message class="chat-message" />
    <chat-input class="chat-input"></chat-input>
    <welcome-vue></welcome-vue>
  </div>
</template>
<script>
import ChatMessage from '@/components/VoiceRoom/component/chat-message.vue';
import ChatInput from '@/components/GameRoom/chat-input.vue';
import WelcomeVue from '@/components/VoiceRoom/component/welcome.vue';

export default {
  name: 'Chat',
  components: {
    'chat-message': ChatMessage,
    'chat-input': ChatInput,
    'welcome-vue': WelcomeVue
  },
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.chat {
  position: relative;
  width: 352px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #1a1828;
  border-radius: 21px;
  overflow: hidden;
}
.chat-title {
  display: flex;
  height: 51px;
  padding: 16px 0;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  flex: none;
  background: rgba(36, 42, 56, 0.46);
  width: 100%;
}
.chat-input {
  flex: none;
  background: #242a38;
}
</style>
